export default __webpack_public_path__ + "static/media/ascension_training_platform_logo_black.7319b18e.svg";